/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Upload_Scan_QrInputs */



/**
* | output |
* | --- |
* | "Scan QR" |
*
* @param {Deck_Upload_Scan_QrInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_upload_scan_qr = /** @type {((inputs?: Deck_Upload_Scan_QrInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Upload_Scan_QrInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Scanner QR")
	if (locale === "es") return /** @type {LocalizedString} */ ("Escanear QR")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Escanear QR")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scansiona QR")
	return /** @type {LocalizedString} */ ("Scan QR")
});